import React, { useState, useEffect } from 'react';
import { getProjectAssignees } from '../../../services/projects.service';
import { SearchableSelect } from '../../common/SearchableSelect';
import type { User } from '../../../types';

interface Props {
  projectId: number;
  value: number | null;
  onChange: (userId: number | null) => void;
  label?: string;
  className?: string;
}

export default function UserSelect({ projectId, value, onChange, label = 'Responsabil', className = '' }: Props) {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getProjectAssignees(projectId)
      .then(data => { if (!cancelled) setUsers(data); })
      .catch(console.error)
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [projectId]);

  return (
    <SearchableSelect
      className={className}
      label={label}
      options={users.map(u => ({
        value: u.id,
        label: u.firstName && u.lastName ? `${u.firstName} ${u.lastName}` : u.login,
      }))}
      value={value ?? ''}
      onChange={v => onChange(v === '' || v == null ? null : Number(v))}
      placeholder={loading ? 'Se încarcă...' : 'Nealocat'}
      disabled={loading}
    />
  );
}
